import { $post, $get, dealError } from "@/utils"
import { router } from "../router"
import { setToken } from "../utils/tools"
import store from "./index"
let loading = false;
const user = {
  state: {
    userInfo: {},
  },
  mutations: {
    SET_USERINFO(state, data) {
      state.userInfo = {...state.userInfo,...data};
    }
  },
  getters: {
    userInfo(state) {
      const token = state.userInfo.token;
      if (!token) {
        store.dispatch("getUserInfo")
      }
      return state.userInfo;
    }
  },
  actions: {
    login({ commit }, params) {
      return new Promise((resolve, reject) => {
        $post("/users/login", params).then(({ data }) => {
          setToken(data.token)
          $get("/task/user", {}, { headers: { token: data.token } }).then(({ data: taskRes }) => {
            commit("SET_USERINFO", { ...data, ...taskRes });
            router.replace({ name: "goods" })
            resolve({ ...data, ...taskRes });
          }).catch(err => {
            dealError(err)
            reject(err)
          })
        }).catch(err => {
          dealError(err)
        })
      })
    },
    getUserInfo({commit}) {
      return new Promise((resolve, reject) => {
        if (loading) return;
        loading = true;
        Promise.all([$get("/users/info")]).then(([{data}]) => {
          loading = false;
          commit("SET_USERINFO", {...data})
        }).catch(err=> {
          loading = false;
          dealError(err)
        })
      })
    },
    updateTaskUserInfo({commit}){
      return new Promise((resolve, reject) => {
        $get("task/user").then(({data}) => {
          commit("SET_USERINFO", data)
        }).catch(err=> {
          dealError(err)
        })
      })
    }
  },
}
export default user
